module.exports = __webpack_public_path__ + "img/walkthrough_illust25@2x.24c1d098.png";